import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleCampaignUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#999" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.74 35.71l3.86 6.44 2.35-4.4H42L37.92 31l-.16.08a11.85 11.85 0 01-7.02 4.63zm-12.37-4.56a12 12 0 006.9 4.54l-3.95 6.44-2.27-4.39H14L18.07 31c0-.02.1.04.3.15z"
        fill="#CCC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.26 34.5A10.5 10.5 0 1138.5 24a10.37 10.37 0 01-10.24 10.5z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.01 29.8l-4.02-2.05-4.07 1.97.79-4.3-3.21-3.12 4.51-.6 2.08-3.9 2 3.93 4.5.7-3.28 3.04.7 4.33z"
        fill="#CCC"
      />
    </svg>
  );
}

SvgPicCircleCampaignUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleCampaignUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleCampaignUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
